import privacyConsent from '../features/privacyConsent';

window.revokeConsent = function () {
    privacyConsent.revokeConsent();
};
